import { computed } from 'vue'
import type { ComputedRef } from 'vue'
import { useDisplay } from 'vuetify'

import type { ICPDialogPropTypes } from '~/portal/components/base'

export const useDialogSize = (): {
	size: ComputedRef<ICPDialogPropTypes['size']>
} => {
	const { width: screenWidth } = useDisplay()

	const size = computed(() => {
		return screenWidth.value <= 639.98 ? 'sm' : 'default'
	})

	return {
		size
	}
}
